import { render, staticRenderFns } from "./IdCardUpload.vue?vue&type=template&id=b51d9150&scoped=true&"
import script from "./IdCardUpload.vue?vue&type=script&lang=js&"
export * from "./IdCardUpload.vue?vue&type=script&lang=js&"
import style0 from "./IdCardUpload.vue?vue&type=style&index=0&id=b51d9150&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51d9150",
  null
  
)

export default component.exports